<div class="unavailable-page">
  <mat-icon
    class="cg-icon-xxl cg-hide-for-print cg-margin-left-sm"
    svgIcon="phosphor-regular-warning-circle"
  ></mat-icon>
  <h3>Currently unavailable</h3>
  <p>
    We apologize for the inconvenience. Please revisit the site at a later time.
  </p>
  <button
    *ngIf="shouldShowRefreshBtn"
    (click)="refreshBrowser()"
    cignaButton="primary"
  >
    Retry
  </button>
</div>
